/**
 * Registers the built-in (creately-curated) starters. Called once before
 * the first registry lookup (idempotent). Registration order is display
 * order within rails — genogram stays first in Popular (creation-balance
 * plan decision #3).
 */

import { registerStarter } from './StarterRegistry'
import { clinicalStarters } from './data/clinicalStarters'
import { operationsStarters } from './data/operationsStarters'
import { generalStarters } from './data/generalStarters'
import { peopleStarters } from './data/peopleStarters'
import { cloudStarters } from './data/cloudStarters'
import { riskStarters } from './data/riskStarters'
import { strategyStarters } from './data/strategyStarters'
import { projectStarters } from './data/projectStarters'
import { softwareStarters } from './data/softwareStarters'
import { PARTNER_PACKS } from './data/partnerPacks'

let registered = false

export function registerDefaultStarters(): void {
  if (registered) return
  registered = true

  for (const group of [
    clinicalStarters,
    operationsStarters,
    peopleStarters,
    generalStarters,
    projectStarters,
    cloudStarters,
    riskStarters,
    strategyStarters,
    softwareStarters,
  ]) {
    for (const starter of group) registerStarter(starter)
  }

  // Partner packs (P4) — same registry, 'partner' namespace; the
  // PARTNER_PACKS requiredFlag hides them for unflagged orgs.
  for (const pack of PARTNER_PACKS) {
    for (const starter of pack.starters) registerStarter(starter)
  }
}
